export default __webpack_public_path__ + "static/media/locationWhite.6a62c93d.svg";